module.exports = __webpack_public_path__ + "media/images/category/feature/index/thum-aoj_a-2e82c0038c7f359d04ba0f32f6c36f04.jpg";